import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class NotificacoesServices extends CommonService {
    constructor(http) {
        super(http);
    }

    verificaTipo(tipo) {
        let urlTipo = "";
        switch (tipo) {
            case 'Entrada':
                urlTipo = "_entrada=true";
                break;
            case 'Saida':
                urlTipo = "_saida=true"
                break;
            default:
                throw new Error(`Necessário informar um tipo [entrada,saida]: tipo informado inválido ou nulo: ${tipo}`)
        }
        return urlTipo;
    }

    buscaPeriodo(cnpj, tipo, range) {
        let url = `dashboards/nfe/periodo/${cnpj}?${this.verificaTipo(tipo)}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }

    buscaTop5(cnpj, tipo, range) {
        let url = `dashboards/nfe/regiao/${cnpj}?${this.verificaTipo(tipo)}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }

    buscaVlrTotal(cnpj, tipo, range) {
        let url = `dashboards/nfe/valor/${cnpj}?${this.verificaTipo(tipo)}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }

    buscaQntdCancelada(cnpj, tipo, range) {
        let url = `dashboards/nfe/cancelada/${cnpj}?${this.verificaTipo(tipo)}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }
    qntNfeEmpresa(id, range) {
        let url = `nfes/qnts/${id}?_range=${range}`;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            });
    }


}


// WEBPACK FOOTER //
// ./src/domain/dashboard/DashBoardService.js